import React, { useEffect, useState } from 'react';

import FormGroup from '../../elements/formElements/FormGroup';

function SeoTagForm({ action, seoTagData, errors }) {
    const [seoTag, setSeoTag] = useState({
        route: '',
        title: '',
        meta_description: '',
        meta_keywords: '',
        og_description: '',
        og_image: '',
        og_url: '',
        og_type: '',
    });

    useEffect(() => {
        if (seoTagData) {
            setSeoTag({
                ...seoTag,
                route: seoTagData.route ?? '',
                title: seoTagData.title ?? '',
                meta_description: seoTagData.meta_description ?? '',
                meta_keywords: seoTagData.meta_keywords ?? '',
                og_description: seoTagData.og_description ?? '',
                og_image: seoTagData.og_description ?? '',
                og_url: seoTagData.og_url ?? '',
                og_type: seoTagData.og_type ?? '',
            });
        }
    }, [seoTagData]);

    function handleSubmit(event) {
        event.preventDefault();
        action(seoTag);
    }

    function getErrorFor(field) {
        if (errors[field]) {
            return errors[field][0];
        }
    }

    return (
        <form onSubmit={handleSubmit} autoComplete="do-not-autofill">
            <FormGroup
                type="text"
                field="route"
                label="Route"
                value={seoTag.route ?? ''}
                error={getErrorFor('route')}
                handleChange={(event) =>
                    setSeoTag({
                        ...seoTag,
                        route: event.target.value,
                    })
                }
            />

            <FormGroup
                type="text"
                field="title"
                label="Title"
                value={seoTag.title ?? ''}
                error={getErrorFor('title')}
                handleChange={(event) =>
                    setSeoTag({
                        ...seoTag,
                        title: event.target.value,
                    })
                }
            />

            <FormGroup
                type="text"
                field="meta_description"
                label="Meta Description"
                value={seoTag.meta_description ?? ''}
                error={getErrorFor('meta_description')}
                handleChange={(event) =>
                    setSeoTag({
                        ...seoTag,
                        meta_description: event.target.value,
                    })
                }
            />

            <FormGroup
                type="text"
                field="meta_keywords"
                label="Meta Keywords"
                value={seoTag.meta_keywords ?? ''}
                error={getErrorFor('meta_keywords')}
                handleChange={(event) =>
                    setSeoTag({
                        ...seoTag,
                        meta_keywords: event.target.value,
                    })
                }
            />

            <FormGroup
                type="text"
                field="og_description"
                label="OG Description"
                value={seoTag.og_description ?? ''}
                error={getErrorFor('og_description')}
                handleChange={(event) =>
                    setSeoTag({
                        ...seoTag,
                        og_description: event.target.value,
                    })
                }
            />

            <FormGroup
                type="text"
                field="og_image"
                label="OG Image"
                value={seoTag.og_image ?? ''}
                error={getErrorFor('og_image')}
                handleChange={(event) =>
                    setSeoTag({
                        ...seoTag,
                        og_image: event.target.value,
                    })
                }
            />

            <FormGroup
                type="text"
                field="og_url"
                label="OG URL"
                value={seoTag.og_url ?? ''}
                error={getErrorFor('og_url')}
                handleChange={(event) =>
                    setSeoTag({
                        ...seoTag,
                        og_url: event.target.value,
                    })
                }
            />

            <FormGroup
                type="text"
                field="og_type"
                label="OG Type"
                value={seoTag.og_type ?? ''}
                error={getErrorFor('og_type')}
                handleChange={(event) =>
                    setSeoTag({
                        ...seoTag,
                        og_type: event.target.value,
                    })
                }
            />

            <button type="submit" className="btn btn-primary">
                Save
            </button>
        </form>
    );
}

export default SeoTagForm;
